/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DashboardDirectoryEntryPointProps } from './DashboardDirectoryEntryPoint.entrypoint.types.tsx';

type DashboardDirectoryEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	DashboardDirectoryEntryPointProps, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any> | null
>;

export const dashboardDirectoryEntryPoint: EntryPoint<DashboardDirectoryEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<DashboardDirectoryEntryPointComponent>(
			/* webpackChunkName: "dashboard-directory-entrypoint" */ './DashboardsDirectoryType.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => {
			return {};
		},
	});
